import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

import { CambiaSeccionEst } from "../../funciones/EstudiantesFunction";

class MateriasInscritas extends Component {
    state = {
        valorSeccion: { value: '', label: '- SELECCIONA UNA SECCIÓN -' },
        secciones: [],
        preloader:{
            icon: "fa fa-circle",
            color: "#9A9A9A" 
        },
        seccion: this.props.datos.seccion
    }

    componentDidMount = () => {
        let materias =  this.props.datos.otraSecc;
        let contenido = [];
        for (let i in materias){
            contenido.push({
                value: materias[i].id, label: `${materias[i].nombre} - SECCIÓN ${materias[i].seccion} - [${materias[i].cupos} CUPOS]`, cupos: materias[i].cupos, seccion: materias[i].seccion
            })
        }
        this.setState({secciones: contenido})
    }

    cambiaSeccion = (valorSeccion) => {
        if (valorSeccion.value === "") return null;

        this.setState({
            valorSeccion,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                color: "#9A9A9A" 
            }
        }, () => {
            if (valorSeccion.cupos === 0){
                toast.error("Esta sección no tiene cupos disponibles",{autoClose: 4000});
                this.setState({
                    valorSeccion: { value: '', label: '- SELECCIONA UNA SECCIÓN -' },
                    preloader:{
                        icon: "fa fa-times",
                        color: "#A0555C"
                    }
                })
            }else{
                CambiaSeccionEst(this.props.datos.id_seccEst, valorSeccion.value, () => {
                    toast.info("Se ha actualizado la sección del estudiante",{autoClose: 4000});
                    this.setState({
                        preloader:{
                            icon: "fa fa-check",
                            color: "#32704C"
                        },
                        seccion: valorSeccion.seccion
                    })
                })
            }
        })
    }

    render() {
        const {datos} = this.props
        let {valorSeccion, secciones, preloader, seccion} = this.state

        const styles = {
            padding: 5, fontSize: 14
        }

        const styles2 = {
            padding: 5, fontSize: 12
        }
        
        return (
            <tr>
                <td style={styles}><strong>{datos.materia}</strong> <span className="text-danger">{`- SECCIÓN ${seccion}`}</span></td>
                <td style={styles2}>
                    <Select
                        isSearchable ={true}
                        value={valorSeccion}
                        onChange={this.cambiaSeccion}
                        options={secciones}
                    />
                </td>
                <td align="center" style={styles2}><i style={{color:preloader.color}} className={preloader.icon}></i></td>
            </tr>
        );
    }
}
 
export default MateriasInscritas;


// WEBPACK FOOTER //
// ./src/views/Registros/MateriasInscritas.jsx